import { Component, OnChanges, Input, Output, SimpleChange, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-password-security-check',
  templateUrl: './password-security-check.component.html',
  styleUrls: ['./password-security-check.component.sass']
})
export class PasswordSecurityCheckComponent implements OnChanges {
    @Input() passwordToCheck: string;
    @Output() change = new EventEmitter<boolean>();

    public level;

    private static measureStrength(p: string) {
        let force = 0;
        let passedMatches = 0;
        const regex = /[$-/:-?{-~!"^`\[\]]/g;
        const lowerLetters = /[a-z]+/.test(p);
        const upperLetters = /[A-Z]+/.test(p);
        const numbers = /[0-9]+/.test(p);
        const symbols = regex.test(p);
        const flags = [ lowerLetters, upperLetters, numbers, symbols ];

        for (const flag of flags) {
          passedMatches += flag === true ? 1 : 0;
        }

        force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
        force += passedMatches * 10;

        // penality (short password)
        force = (p.length <= 6) ? Math.min(force, 10) : force;

        // penality (poor variety of characters)
        force = (passedMatches === 1) ? Math.min(force, 10) : force;
        force = (passedMatches === 2) ? Math.min(force, 20) : force;
        force = (passedMatches === 3) ? Math.min(force, 40) : force;

        return force;
    }

    ngOnChanges(changes: {[propName: string]: SimpleChange}): void {
        const password = changes['passwordToCheck'].currentValue;

        if (password) {
          const force = PasswordSecurityCheckComponent.measureStrength(password);
          const level = Math.floor(force / 10);
          this.level = level <= 5 ? level : 5;
        } else {
          this.level = 0;
        }

        this.change.emit(this.level);
    }
}
